import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { defaultRichTextPatterns, renderHighlightTextContent, RichTextPattern } from './renderHighlightTextContent';

type GlowHighlightTextProps = {
    text: string;
    patterns?: RichTextPattern[];
};

export const GlowHighlightText: ComponentMemo<GlowHighlightTextProps> = memo(({ text }) => {
    return renderHighlightTextContent(text, defaultRichTextPatterns);
});

GlowHighlightText.displayName = 'GlowHighlightText';
